define('app/sf/circular/sf-circular-filter',["circular-json"], function (circularJson) {
	return function circularJsonFilter(input) {
		return circularJson.stringify(input, null, "    ");
	};
});
